export default __webpack_public_path__ + "static/media/tiktok.f373d73f.svg";